module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "id": "fm1",
      "title": "Foreword"
    }
  }, [_c('p', {
    staticClass: "fm_headab"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Contents#rfm1"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig_10"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "non_para"
  }, [_c('i', [_vm._v("For their helpful advice and criticism I want to thank Helen Thurber,")]), _vm._v(" Gus Lobrano, Kenneth MacLean and John McGiffert. I am indebted to Harcourt Brace for their permission to include six stories from “"), _c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My World and Welcome to It")]), _vm._v(",” and “"), _c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_65#ch114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War Between Men and Women")]), _vm._v("” and a number of other drawings from “"), _c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#pt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men, Women and Dogs")]), _vm._v(".” “"), _c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recollections of the Gas Buggy")]), _vm._v("” is reprinted through the courtesy of "), _c('i', [_vm._v("The Saturday Review of Literature.")]), _vm._v(" The other pieces of the drawings originally appeared in "), _c('i', [_vm._v("The New Yorker.")])]), _vm._v(" "), _c('p', {
    staticClass: "in_para"
  }, [_vm._v("Most of the books represented here were published under the supervision of the late Gene Saxton, and this anthology was his idea. I salute the memory of a good friend and a wise and kindly counsellor.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d82a74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780063075771_Foreword.vue
// module id = 69
// module chunks = 0